// extracted by mini-css-extract-plugin
module.exports = {"Button":"ajevik7blFiPpl8rqHzrE","error":"_3i2F2hSYmJr-6SKPFJe8Aw","success":"_1wqIAlCYQsq9KAocDus16O","primary":"_2Limk5MVXprVj6A3ZNryrL"};